import { SlArrowDown } from 'react-icons/sl';

export function Faq({ title, questions }) {
  return (
    <>
      <h3 className="collapse-header py-5 container text-center">{title}</h3>
      <div className="container px-5 pb-4 ">
        {questions.map((value, index) => (
          <>
            <div
              data-bs-toggle="collapse"
              href={`#multiCollapseExample${index}`}
              role="button"
              className="collapse-title  d-flex justify-content-between"
              aria-expanded="false"
              aria-controls={`multiCollapseExample${index}`}
            >
              <p>{value.question}</p>
              <SlArrowDown color="#000" />
            </div>
            <div class="col-12">
              <div
                class="collapse multi-collapse"
                id={`multiCollapseExample${index}`}
              >
                <div class="color-black  text-start pt-3 pb-5">
                  {value.answer}
                </div>
              </div>
            </div>
          </>
        ))}
      </div>
    </>
  );
}
